import React from 'react';
import { Outlet } from 'react-router-dom';

// *** ESTA LÍNEA ES LA QUE CAMBIA: Intenta subir un nivel ***
import Sidebar from './Sidebar';

/**
 * Componente de layout administrativo que incluye el Sidebar fijo
 * y renderiza el contenido de la ruta actual.
 */
export default function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-gray-100">
      
      {/* 1. Sidebar Fijo */}
      <Sidebar />
      
      {/* 2. Contenido Principal */}
      <main className="flex-grow ml-64">
        {/* Outlet renderiza el componente de la ruta actual (Dashboard, Consultorios, etc.) */}
        <Outlet />
      </main>
      
    </div>
  );
}